(function () {
  'use strict';

  /* =========================================================
     HELPERS
  ========================================================= */

  function normalizeUrl(url) {
    if (!url) return '';

    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    }

    return url;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function isDesignObject(obj) {
    return !!(obj && obj.blvUserArtwork === true);
  }

  function getDesignObjects(canvas) {
    if (!canvas) return [];

    return canvas.getObjects().filter(isDesignObject);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function readProductData(root) {
    var el = root.querySelector('[data-blv-customizer-product]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[blvnks-customizer] Failed to parse product JSON', error);
      return null;
    }
  }

  function getSelectedVariantId(productData) {
    /*
     * Prefer the live product form value over the URL. Shopify themes often
     * update the selected variant in the DOM before history.replaceState()
     * updates ?variant=, so reading the URL first can return the PREVIOUS
     * color when the customer immediately opens the customizer.
     */
    if (productData && productData.colorOverride && productData.selectedVariantId) {
      return String(productData.selectedVariantId);
    }
    var productId = productData && productData.id
      ? String(productData.id)
      : '';

    var productInfo = productId
      ? document.querySelector('product-info[data-product-id="' + productId + '"]')
      : null;

    var variantInput = null;

    if (productInfo) {
      variantInput = productInfo.querySelector(
        'form[action*="/cart/add"] [name="id"], input[name="id"]'
      );
    }

    if (!variantInput) {
      variantInput =
        document.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('input[name="id"]');
    }

    if (variantInput && variantInput.value) {
      return String(variantInput.value);
    }

    /* Dawn-style variant-selects keeps a selected-variant JSON node. */
    var picker = productId
      ? document.querySelector('variant-selects[data-product-id="' + productId + '"]')
      : document.querySelector('variant-selects');

    if (picker) {
      var selectedVariantEl = picker.querySelector('[data-selected-variant]');

      if (selectedVariantEl) {
        try {
          var selectedVariant = JSON.parse(selectedVariantEl.textContent);
          if (selectedVariant && selectedVariant.id) {
            return String(selectedVariant.id);
          }
        } catch (error) {
          /* Fall through to URL / selected option matching. */
        }
      }
    }

    var url = new URL(window.location.href);
    var variantParam = url.searchParams.get('variant');

    if (productData && productData.selectedVariantId) {
      return String(productData.selectedVariantId);
    }

    if (variantParam) return String(variantParam);

    return '';
  }

  function getLiveSelectedOptions(productData) {
    var values = {};
    var productId = productData && productData.id
      ? String(productData.id)
      : '';

    var picker = productId
      ? document.querySelector('variant-selects[data-product-id="' + productId + '"]')
      : document.querySelector('variant-selects');

    if (!picker) return values;

    picker.querySelectorAll('input:checked, select').forEach(function (node) {
      var name = node.getAttribute('name') || '';
      var match = name.match(/^options\[(.+)\]$/);

      if (!match) return;

      values[match[1]] = node.value;
    });

    return values;
  }

  function findVariantFromSelectedOptions(productData) {
    if (!productData || !Array.isArray(productData.variants)) {
      return null;
    }

    var optionNames = Array.isArray(productData.options)
      ? productData.options
      : [];

    var selected = getLiveSelectedOptions(productData);
    var selectedNames = Object.keys(selected);

    if (!selectedNames.length) return null;

    for (var i = 0; i < productData.variants.length; i += 1) {
      var variant = productData.variants[i];
      var matches = true;

      for (var position = 0; position < optionNames.length; position += 1) {
        var optionName = optionNames[position];

        /*
         * Size is intentionally allowed to be absent because BLVNKS replaces
         * the normal size picker with the size-run table. Matching the live
         * Color (and any other visible option) is enough to choose the correct
         * garment image.
         */
        if (selected[optionName] == null || selected[optionName] === '') {
          continue;
        }

        if (String(variant.options[position]) !== String(selected[optionName])) {
          matches = false;
          break;
        }
      }

      if (matches) return variant;
    }

    return null;
  }

  function findVariant(productData, variantId) {
    if (!productData || !productData.variants || !productData.variants.length) {
      return null;
    }

    if (variantId) {
      for (var i = 0; i < productData.variants.length; i += 1) {
        if (String(productData.variants[i].id) === String(variantId)) {
          return productData.variants[i];
        }
      }
    }

    return productData.variants[0];
  }

  function getVariantImageUrl(productData) {
    /*
     * First match the CURRENT visible option selection. This is the most
     * reliable source when the customer switches colors and immediately
     * presses “Design this blank”.
     */
    var variant = null;

    if (productData && productData.colorOverride) {
      variant = findVariant(productData, productData.selectedVariantId);
    }

    if (!variant) {
      variant = findVariantFromSelectedOptions(productData);
    }

    if (!variant) {
      var selectedVariantId = getSelectedVariantId(productData);
      variant = findVariant(productData, selectedVariantId);
    }

    if (variant && variant.image) {
      return normalizeUrl(variant.image);
    }

    if (
      productData &&
      productData.media &&
      productData.media.length &&
      productData.media[0].url
    ) {
      return normalizeUrl(productData.media[0].url);
    }

    return '';
  }

  /*
   * Preview calibration copied from the Production Builder. Keep this in
   * lockstep with GARMENT_PROFILES.preview / .limits / .custom in
   * blvnks-production.js until the two files share one config module.
   */
  var UNITS_PER_INCH_FALLBACK = 52 / 21;

  var GARMENT_PROFILES = {
    tee: {
      preview: {
        front: {
          unitsPerInch: 2.161,
          printArea: { x: 32.95, y: 28.32, w: 34.58, h: 45.38 },
          placements: {
            'left-chest': { cx: 0.60, cy: 0.41 },
            'custom-front': { cx: 0.50, cy: 0.46 }
          }
        },
        back: {
          unitsPerInch: 2.161,
          printArea: { x: 32.95, y: 28.32, w: 34.58, h: 45.38 },
          placements: {
            'custom-back': { cx: 0.50, cy: 0.45 }
          }
        }
      },
      limits: {
        'left-chest': { w: 5, h: 6 },
        'custom-front': { w: 14, h: 18 },
        'custom-back': { w: 14, h: 19 }
      }
    },
    hoodie: {
      preview: {
        front: {
          unitsPerInch: 2.15,
          printArea: { x: 34, y: 34, w: 32, h: 31 },
          placements: {
            'left-chest': { cx: 0.59, cy: 0.46 },
            'custom-front': { cx: 0.50, cy: 0.51 }
          }
        },
        back: {
          unitsPerInch: 2.15,
          printArea: { x: 32.8, y: 34, w: 34.4, h: 45.15 },
          placements: {
            'custom-back': { cx: 0.50, cy: 0.52 }
          }
        }
      },
      limits: {
        'left-chest': { w: 5, h: 6 },
        'custom-front': { w: 12, h: 14 },
        'custom-back': { w: 14, h: 18 }
      }
    },
    crewneck: {
      custom: {
        front: { x: 24, y: 22, w: 52, h: 70 },
        back: { x: 24, y: 19, w: 52, h: 74 }
      },
      preview: {
        front: {
          unitsPerInch: 1.997,
          printArea: { x: 33.34, y: 42.31, w: 31.95, h: 37.94 }
        },
        back: {
          unitsPerInch: 1.997,
          printArea: { x: 33.34, y: 42.31, w: 31.95, h: 37.94 }
        }
      },
      limits: {
        'left-chest': { w: 5, h: 6 },
        'custom-front': { w: 14, h: 18 },
        'custom-back': { w: 14, h: 19 }
      }
    },
    tank: {
      custom: {
        front: { x: 30, y: 24, w: 40, h: 68 },
        back: { x: 30, y: 21, w: 40, h: 71 }
      },
      preview: {
        front: {
          unitsPerInch: 2.476,
          printArea: { x: 30.19, y: 24, w: 39.62, h: 52 }
        },
        back: {
          unitsPerInch: 2.476,
          printArea: { x: 30.19, y: 21, w: 39.62, h: 52 }
        }
      },
      limits: {
        'left-chest': { w: 4.5, h: 5 },
        'custom-front': { w: 11, h: 17 },
        'custom-back': { w: 11, h: 18 }
      }
    }
  };

  function garmentProfile(productData) {
    var explicit = String(
      productData && productData.profile
        ? productData.profile
        : ''
    ).toLowerCase().replace(/[^a-z0-9-]/g, '');

    var hint = (
      (productData && productData.title ? productData.title : '') + ' ' +
      (productData && productData.handle ? productData.handle : '')
    ).toLowerCase();

    var key = explicit;
    if (!key || key === 'tee' || !GARMENT_PROFILES[key]) {
      if (hint.indexOf('hoodie') !== -1) key = 'hoodie';
      else if (hint.indexOf('crew') !== -1) key = 'crewneck';
      else if (hint.indexOf('tank') !== -1) key = 'tank';
      else key = 'tee';
    }

    return GARMENT_PROFILES[key] || GARMENT_PROFILES.tee;
  }

  function previewSideKey(view) {
    return view === 'back' ? 'back' : 'front';
  }

  function getPreviewGeometry(productData, view) {
    var profile = garmentProfile(productData);
    var side = previewSideKey(view);
    var preview = profile.preview && profile.preview[side]
      ? profile.preview[side]
      : null;
    var custom = profile.custom && profile.custom[side]
      ? profile.custom[side]
      : null;

    var printArea = preview && preview.printArea
      ? preview.printArea
      : (custom || { x: 24, y: 22, w: 52, h: 70 });

    var unitsPerInch = preview && Number(preview.unitsPerInch) > 0
      ? Number(preview.unitsPerInch)
      : UNITS_PER_INCH_FALLBACK;

    var limitKey = view === 'back'
      ? 'custom-back'
      : 'custom-front';
    var limits = profile.limits || {};
    var limit = limits[limitKey] || { w: 14, h: 18 };

    return {
      printArea: printArea,
      unitsPerInch: unitsPerInch,
      minWidthIn: 1,
      maxWidthIn: Number(limit.w) > 0 ? Number(limit.w) : 14,
      maxHeightIn: Number(limit.h) > 0 ? Number(limit.h) : 18,
      placement: preview && preview.placements
        ? (
          view === 'left-chest'
            ? preview.placements['left-chest']
            : preview.placements[side === 'back' ? 'custom-back' : 'custom-front']
        )
        : null
    };
  }

  function productionBackImages(media) {
    var map = {};

    (media || []).forEach(function (item) {
      if (!item || !item.alt || !item.url) return;

      var match = String(item.alt).match(/^production-back\s*:\s*(.+)$/i);
      if (!match) return;

      var color = match[1].trim().toLowerCase();
      if (color) {
        map[color] = normalizeUrl(item.url);
      }
    });

    return map;
  }

  function getCurrentColorName(productData) {
    var optionNames = Array.isArray(productData && productData.options)
      ? productData.options
      : [];
    var i;

    if (productData && productData.colorOverride) {
      var overridden = findVariant(productData, productData.selectedVariantId);
      if (overridden) {
        for (i = 0; i < optionNames.length; i += 1) {
          if (/colou?r/i.test(String(optionNames[i]))) {
            return String(overridden.options[i] || '').trim();
          }
        }
        return String(overridden.title || '').split(' / ')[0].trim();
      }
    }

    var selected = getLiveSelectedOptions(productData);

    for (i = 0; i < optionNames.length; i += 1) {
      if (/colou?r/i.test(String(optionNames[i]))) {
        if (selected[optionNames[i]]) {
          return String(selected[optionNames[i]]).trim();
        }
        break;
      }
    }

    var variant = findVariantFromSelectedOptions(productData);

    if (!variant) {
      variant = findVariant(
        productData,
        getSelectedVariantId(productData)
      );
    }

    if (!variant) return '';

    for (i = 0; i < optionNames.length; i += 1) {
      if (/colou?r/i.test(String(optionNames[i]))) {
        return String(variant.options[i] || '').trim();
      }
    }

    return String(variant.title || '').split(' / ')[0].trim();
  }

  function getGarmentImageForView(productData, view) {
    var frontUrl = getVariantImageUrl(productData);

    if (view !== 'back') {
      return frontUrl;
    }

    var color = getCurrentColorName(productData);
    var map = productionBackImages(productData && productData.media);
    var backUrl = map[String(color).trim().toLowerCase()] || '';

    if (!backUrl) {
      console.warn(
        '[blvnks-customizer] No production-back image for color',
        color
      );
      return frontUrl;
    }

    return backUrl;
  }

  var SIZE_ORDER = [
    'XXS', 'XS', 'S', 'M', 'L', 'XL',
    '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL'
  ];

  function optionIndex(productData, kind) {
    var options = Array.isArray(productData && productData.options)
      ? productData.options
      : [];
    var i;

    for (i = 0; i < options.length; i += 1) {
      if (kind === 'color' && /colou?r/i.test(String(options[i]))) return i;
      if (kind === 'size' && /size/i.test(String(options[i]))) return i;
    }

    return kind === 'size' ? 1 : 0;
  }

  var COLOR_SWATCHES = {
    'deep black': '#111111',
    black: '#111111',
    white: '#f5f5f2',
    bone: '#ded5c2',
    cream: '#e8dfcc',
    natural: '#e7dfcf',
    grey: '#8a8a88',
    gray: '#8a8a88',
    'vintage grey': '#777673',
    'vintage gray': '#777673',
    'washed grey': '#858481',
    'washed gray': '#858481',
    sage: '#9ba38d',
    matcha: '#a5aa83',
    navy: '#252d3d',
    brown: '#6f5847',
    maroon: '#5c2028',
    red: '#9a2d2d',
    blue: '#4e6480',
    charcoal: '#3a3a3a',
    'cardinal red': '#8b1e1e',
    lime: '#9dbb3c',
    'dark chocolate': '#4a3228',
    'forest green': '#2f4f3e',
    gold: '#c4a35a'
  };

  var TEXT_FONTS = [
    'Arial',
    'Helvetica',
    'Georgia',
    'Times New Roman',
    'Courier New',
    'Trebuchet MS',
    'Verdana',
    'Impact'
  ];

  function swatchHex(colorName) {
    return COLOR_SWATCHES[String(colorName || '').toLowerCase().trim()] || '#d9d9d9';
  }

  function isTextObject(obj) {
    if (!obj) return false;
    if (obj.blvKind === 'text') return true;
    var type = String(obj.type || '');
    return type === 'textbox' || type === 'text' || type === 'i-text';
  }

  function formatMoney(cents, currency) {
    var value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function nextOrderRowId() {
    return 'or' + Math.random().toString(36).slice(2, 8);
  }

  /* =========================================================
     CUSTOMIZER CONTROLLER
  ========================================================= */

  function Customizer(root) {
    this.root = root;
    this.productData = readProductData(root);

    this.canvasWrap = root.querySelector('[data-blv-customizer-canvas-wrap]');
    this.canvasEl = root.querySelector('[data-blv-customizer-canvas]');
    this.centerAddButton = root.querySelector('.blv-customizer__add-art[data-blv-open-uploads]');
    this.uploadOpenButtons = root.querySelectorAll('[data-blv-open-uploads]');
    this.designPanel = root.querySelector('[data-blv-design-panel]');
    this.panelHead = root.querySelector('[data-blv-panel-title]');
    this.barStatus = root.querySelector('[data-blv-bar-status]');
    this.toolButtons = root.querySelectorAll('[data-blv-tool]');
    this.activeTool = 'design';
    this.openButtons = document.querySelectorAll('[data-blv-open-customizer]');
    this.closeButton = root.querySelector('[data-blv-close-customizer]');
    this.viewsWrap = root.querySelector('[data-blv-customizer-views]');

    this.currentView = 'front';

    this.viewState = {
      front: [],
      back: [],
      'left-chest': []
    };

    this.savedUploads = [];

    this.editor = null;
    this._suspendCanvasSync = false;
    this.standalone = root.getAttribute('data-blv-standalone') === 'true';
    this.exitUrl = root.getAttribute('data-blv-exit-url') || '';
    this.currency = root.getAttribute('data-blv-currency') || 'USD';
    this.productionUrl = root.getAttribute('data-blv-production-url') || '/pages/production';
    this.designedEndpoint = root.getAttribute('data-blv-designed-endpoint') || '/apps/blvnks/designed';
    this.uploadEndpoint = root.getAttribute('data-blv-upload-endpoint') || '/apps/blvnks/dtf';
    this.jumpVariantId = Number(root.getAttribute('data-blv-jump-variant') || 0);
    this.jumpPriceCents = Number(root.getAttribute('data-blv-jump-cents') || 2000);
    this.uploadCaps = null;
    this.orderSheet = root.querySelector('[data-blv-order-sheet]');
    this.orderRowsEl = root.querySelector('[data-blv-order-rows]');
    this.orderRows = [];
    this.orderDraft = { color: '', size: '' };
    this.orderSubmitting = false;

    this.init();
  }

  Customizer.prototype.init = function () {
    if (!window.fabric) {
      console.warn('[blvnks-customizer] Fabric.js is not loaded');
      return;
    }

    if (!window.BlvnksArtworkEditor) {
      console.warn('[blvnks-customizer] BlvnksArtworkEditor is not loaded');
      return;
    }

    this.initLauncher();
    this.initTools();
    this.initOrderSheet();
    this.bindStageExpand();
    this.bindGlobalVariantSync();

    if (this.standalone || !this.root.classList.contains('blv-customizer--closed')) {
      this.open();
    }
  };

  /* =========================================================
     EDITOR SETUP
  ========================================================= */

  Customizer.prototype.initEditor = function () {
    if (this.editor) return;

    var garmentUrl = getGarmentImageForView(this.productData, this.currentView);
    var geo = getPreviewGeometry(this.productData, this.currentView);

    if (!garmentUrl) {
      console.warn('[blvnks-customizer] No garment image found');
      return;
    }

    var containerWidth = this.canvasWrap
      ? this.canvasWrap.clientWidth
      : 0;

    this.editor = new window.BlvnksArtworkEditor({
      canvas: this.canvasEl,
      container: this.canvasWrap,
      logicalWidth: 100,
      logicalHeight: 110,
      minCanvasWidth: 240,
      maxCanvasWidth: Math.min(Math.max(containerWidth || 280, 280), 520),
      garmentUrl: garmentUrl,
      artworkUrl: null,
      artworkName: '',
      printArea: geo.printArea,
      unitsPerInch: geo.unitsPerInch,
      minWidthIn: geo.minWidthIn,
      maxWidthIn: geo.maxWidthIn,
      minAngle: -45,
      maxAngle: 45,
      state: {
        cx: 50,
        cy: 55,
        angle: 0,
        widthIn: 4
      },
      onError: function (err) {
        console.warn('[blvnks-customizer] editor error', err);
      }
    });

    this.root._blvnksCustomizerEditor = this.editor;

    this.bindCanvasEvents();

    if (this.viewsWrap) {
      this.viewsWrap.hidden = false;
      this.bindViewButtons();
    }
  };

  Customizer.prototype.bindCanvasEvents = function () {
    if (!this.editor || !this.editor.canvas) return;

    var self = this;

    this.editor.canvas.on('selection:created', function () {
      if (self._suspendCanvasSync) return;
      self.setActiveTool('design');
      self.renderDesignPanel();
    });

    this.editor.canvas.on('selection:updated', function () {
      if (self._suspendCanvasSync) return;
      self.setActiveTool('design');
      self.renderDesignPanel();
    });

    this.editor.canvas.on('selection:cleared', function () {
      if (self._suspendCanvasSync) return;
      self.refreshActivePanel();
    });

    this.editor.canvas.on('object:added', function (evt) {
      if (self._suspendCanvasSync) return;
      if (evt && evt.target && !isDesignObject(evt.target)) return;
      self.syncCurrentViewState();
      self.refreshActivePanel();
      self.updateAddArtVisibility();
    });

    this.editor.canvas.on('object:modified', function (evt) {
      if (self._suspendCanvasSync) return;
      if (evt && evt.target && !isDesignObject(evt.target)) return;
      self.syncCurrentViewState();
      if (self.activeTool === 'design') self.renderDesignPanel();
      self.updateAddArtVisibility();
    });

    this.editor.canvas.on('object:removed', function (evt) {
      if (self._suspendCanvasSync) return;
      if (evt && evt.target && !isDesignObject(evt.target)) return;
      self.syncCurrentViewState();
      self.refreshActivePanel();
      self.updateAddArtVisibility();
    });
  };

  Customizer.prototype.bindViewButtons = function () {
    var self = this;
    var buttons = this.viewsWrap.querySelectorAll('[data-view]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.switchView(button.getAttribute('data-view'));
      });
    });

    this.updateViewButtons();
  };

  Customizer.prototype.updateViewButtons = function () {
    if (!this.viewsWrap) return;

    var self = this;
    var names = {
      front: 'Front',
      back: 'Back',
      'left-chest': 'Left Chest'
    };

    this.viewsWrap.querySelectorAll('[data-view]').forEach(function (btn) {
      var active = btn.getAttribute('data-view') === self.currentView;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var label = this.root.querySelector('.blv-customizer__view-label');
    if (label) {
      label.textContent = names[this.currentView] || 'Front';
    }
  };

  Customizer.prototype.applyViewGeometry = function (view) {
    if (!this.editor) return;

    var geo = getPreviewGeometry(this.productData, view);

    this.editor.minWidthIn = geo.minWidthIn;
    this.editor.maxWidthIn = geo.maxWidthIn;

    if (this.editor.options) {
      this.editor.options.minWidthIn = geo.minWidthIn;
      this.editor.options.maxWidthIn = geo.maxWidthIn;
    }

    if (typeof this.editor.setPrintGeometry === 'function') {
      this.editor.setPrintGeometry(geo.printArea, geo.unitsPerInch);
      return;
    }

    this.editor.unitsPerInch = geo.unitsPerInch;

    if (this.editor.options) {
      this.editor.options.unitsPerInch = geo.unitsPerInch;
      this.editor.options.printArea = geo.printArea;
    }

    if (typeof this.editor.buildPrintBounds === 'function') {
      this.editor.printBounds = this.editor.buildPrintBounds(geo.printArea);
    }

    if (typeof this.editor.refreshPrintGuide === 'function') {
      this.editor.refreshPrintGuide();
    }
  };

  Customizer.prototype.switchView = function (view) {
    if (!view || !this.editor || !this.editor.canvas) return;

    if (view === this.currentView) {
      this.updateViewButtons();
      return;
    }

    this.syncCurrentViewState();
    this._suspendCanvasSync = true;
    this.currentView = view;
    this.clearDesignObjects();
    this.applyViewGeometry(view);
    this.syncVariantGarment();
    this.loadViewState(view);
    this.updateViewButtons();
    this.refreshActivePanel();
    this.updateAddArtVisibility();
  };

  Customizer.prototype.clearDesignObjects = function () {
    if (!this.editor || !this.editor.canvas) return;

    var canvas = this.editor.canvas;

    getDesignObjects(canvas).forEach(function (obj) {
      canvas.remove(obj);
    });

    canvas.discardActiveObject();
    canvas.requestRenderAll();
  };

  Customizer.prototype.syncCurrentViewState = function () {
    if (!this.editor || !this.editor.canvas || this._suspendCanvasSync) return;

    var objects = getDesignObjects(this.editor.canvas);

    var serialized = objects.map(function (obj) {
      return obj.toObject([
        'name',
        'sourcePath',
        'crossOrigin',
        'blvUserArtwork',
        'blvKind',
        'blvPreviewUrl'
      ]);
    });

    this.viewState[this.currentView] = serialized;
  };

  Customizer.prototype.loadViewState = function (view, options) {
    var self = this;
    options = options || {};

    if (!this.editor || !this.editor.canvas) {
      return Promise.resolve();
    }

    var canvas = this.editor.canvas;
    var data = this.viewState[view] || [];
    var keepSuspended = options.keepSuspended === true;

    this._suspendCanvasSync = true;

    getDesignObjects(canvas).forEach(function (obj) {
      canvas.remove(obj);
    });

    return new Promise(function (resolve) {
      function finishLoad() {
        canvas.discardActiveObject();
        canvas.requestRenderAll();

        if (!keepSuspended) {
          self._suspendCanvasSync = false;
          self.refreshActivePanel();
          self.updateAddArtVisibility();
        }

        resolve();
      }

      if (!data.length) {
        finishLoad();
        return;
      }

      fabric.util.enlivenObjects(data, function (enlivenedObjects) {
        enlivenedObjects.forEach(function (obj) {
          obj.set({
            blvUserArtwork: true,
            blvKind: obj.blvKind || 'artwork'
          });

          canvas.add(obj);
        });

        finishLoad();
      });
    });
  };

  Customizer.prototype.refreshEditor = function () {
    var self = this;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (self.editor && typeof self.editor.resize === 'function') {
          self.editor.resize();
        }

        self.setHandleSize(self.root.classList.contains('is-stage-expanded'));

        window.dispatchEvent(new Event('resize'));

        self.root.querySelectorAll('.upper-canvas').forEach(function (canvas) {
          canvas.style.pointerEvents = 'auto';
        });
      });
    });
  };

  /* =========================================================
     OPEN / CLOSE
  ========================================================= */

  Customizer.prototype.initLauncher = function () {
    var self = this;

    this.openButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        self.open();
      });
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        self.close();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (self.isOrderSheetOpen()) {
        self.closeOrderSheet();
        return;
      }

      if (!self.root.classList.contains('blv-customizer--closed')) {
        self.close();
      }
    });
  };

  Customizer.prototype.open = function () {
    var self = this;

    this.root.classList.remove('blv-customizer--closed');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('blv-customizer-open');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!self.editor) {
          self.initEditor();
          self.renderDesignPanel();
          self.updateAddArtVisibility();
        } else {
          self.syncVariantGarment();
          self.refreshEditor();
        }

        var headerOffset = parseInt(
          getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height'),
          10
        ) || 0;

        var top =
          self.root.getBoundingClientRect().top +
          window.scrollY -
          headerOffset -
          16;

        if (
          !self.standalone &&
          window.matchMedia('(min-width: 901px)').matches
        ) {
          window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
          });
        }
      });
    });
  };

  Customizer.prototype.bindStageExpand = function () {
    var self = this;
    var button = this.root.querySelector('[data-blv-expand-stage]');

    if (!button) return;

    button.addEventListener('click', function () {
      var expanded = self.root.classList.toggle('is-stage-expanded');

      button.setAttribute('aria-pressed', expanded ? 'true' : 'false');
      button.setAttribute('aria-label', expanded ? 'Shrink garment' : 'Enlarge garment');
      self.canvasWrap.style.width = '';
      self.canvasWrap.style.maxHeight = '';

      requestAnimationFrame(function () {
        if (expanded && self.canvasWrap) {
          var stage = self.root.querySelector('.blv-customizer__stage');
          var availH = Math.max(220, (stage ? stage.clientHeight : 0) - 56);
          var availW = Math.max(220, (stage ? stage.clientWidth : 0) - 8);
          var width = Math.min(availW, Math.floor(availH * 100 / 110));
          /* Phone width already fills the stage, so grow 10% and let the stage crop the margin. */
          width = Math.round(width * 1.1);
          self.canvasWrap.style.width = width + 'px';
          self.canvasWrap.style.maxHeight = 'none';
        }

        if (self.editor && self.editor.options) {
          self.editor.options.maxCanvasWidth = expanded ? 1100 : 520;
        }

        self.refreshEditor();
      });
    });
  };

  Customizer.prototype.setHandleSize = function (expanded) {
    if (!this.editor || !this.editor.canvas) return;

    var size = expanded ? 22 : 13;
    var touch = expanded ? 34 : 22;

    this.editor.canvas.getObjects().forEach(function (obj) {
      if (!obj.selectable) return;
      obj.cornerSize = size;
      obj.touchCornerSize = touch;
      obj.padding = expanded ? 8 : 0;
      obj.setCoords();
    });

    this.editor.canvas.requestRenderAll();
  };

  Customizer.prototype.close = function () {
    this.root.classList.remove('is-stage-expanded');

    if (this.exitUrl) {
      window.location.href = this.exitUrl;
      return;
    }

    this.root.classList.add('blv-customizer--closed');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('blv-customizer-open');
  };

  /* =========================================================
     VARIANT / COLOR SYNC
  ========================================================= */

  Customizer.prototype.bindGlobalVariantSync = function () {
    var self = this;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.closest('[data-blv-design-panel], [data-blv-order-sheet]')) {
        return;
      }

      if (
        target.name === 'id' ||
        target.matches('[name="id"]') ||
        target.matches('input[type="radio"]') ||
        target.matches('select')
      ) {
        /*
         * Theme variant rendering can finish asynchronously. Sync immediately
         * from the checked swatch, then once more after Dawn updates its
         * selected variant / URL.
         */
        self.syncVariantGarment();

        setTimeout(function () {
          self.syncVariantGarment();
        }, 120);

        setTimeout(function () {
          self.syncVariantGarment();
        }, 350);
      }
    });

    window.addEventListener('popstate', function () {
      self.syncVariantGarment();
    });
  };

  Customizer.prototype.syncVariantGarment = function () {
    var self = this;
    var garmentUrl = getGarmentImageForView(
      this.productData,
      this.currentView
    );

    if (!garmentUrl || !this.editor || !this.editor.canvas) {
      return Promise.resolve();
    }

    var currentUrl = normalizeUrl(
      this.editor.garmentUrl ||
      (this.editor.options && this.editor.options.garmentUrl) ||
      ''
    );

    if (currentUrl === garmentUrl && this.editor.garmentObject) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var settled = false;

      function done() {
        if (settled) return;
        settled = true;
        resolve();
      }

      window.setTimeout(done, 2000);

      /*
       * Newer artwork-editor builds may expose setGarmentImage(). Use it when
       * available. The fallback below makes this file safe with the current
       * BLVNKS artwork-editor build too, so variant/color switching cannot get
       * stuck on the first garment image.
       */
      if (typeof self.editor.setGarmentImage === 'function') {
        self.editor.setGarmentImage(garmentUrl, function () {
          self.refreshEditor();
          done();
        });
        self.editor.garmentUrl = garmentUrl;

        if (self.editor.options) {
          self.editor.options.garmentUrl = garmentUrl;
        }

        return;
      }

      var canvas = self.editor.canvas;
      var loadId = (self._garmentLoadId || 0) + 1;
      self._garmentLoadId = loadId;

      var imageOptions = /^https?:/i.test(String(garmentUrl))
        ? { crossOrigin: 'anonymous' }
        : {};

      fabric.Image.fromURL(
        garmentUrl,
        function (garment) {
          if (!garment || self._garmentLoadId !== loadId) {
            done();
            return;
          }

          var width = canvas.getWidth();
          var height = canvas.getHeight();
          var garmentScale = Math.min(
            width / Math.max(garment.width || 1, 1),
            height / Math.max(garment.height || 1, 1)
          );

          garment.set({
            left: width / 2,
            top: height / 2,
            originX: 'center',
            originY: 'center',
            scaleX: garmentScale,
            scaleY: garmentScale,
            selectable: false,
            evented: false,
            objectCaching: false,
            excludeFromExport: true,
            blvGarmentObject: true
          });

          self._suspendCanvasSync = true;

          if (self.editor.garmentObject) {
            canvas.remove(self.editor.garmentObject);
          }

          self.editor.garmentObject = garment;
          self.editor.garmentUrl = garmentUrl;

          if (self.editor.options) {
            self.editor.options.garmentUrl = garmentUrl;
          }

          canvas.add(garment);
          garment.sendToBack();
          canvas.requestRenderAll();

          self._suspendCanvasSync = false;
          self.refreshEditor();
          done();
        },
        imageOptions
      );
    });
  };

  /* =========================================================
     TOOLS / PANELS
  ========================================================= */

  Customizer.prototype.initTools = function () {
    var self = this;

    this.toolButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var tool = button.getAttribute('data-blv-tool');
        self.setActiveTool(tool);
        self.refreshActivePanel();
      });
    });

    this.uploadOpenButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        self.setActiveTool('uploads');
        self.renderUploadsPanel();
      });
    });
  };

  Customizer.prototype.setActiveTool = function (toolName) {
    this.activeTool = toolName || 'design';

    this.toolButtons.forEach(function (btn) {
      btn.classList.toggle(
        'is-active',
        btn.getAttribute('data-blv-tool') === toolName
      );
    });

    var titles = {
      design: 'Design',
      color: 'Color',
      uploads: 'Uploads',
      text: 'Text'
    };

    if (this.panelHead) {
      this.panelHead.textContent = titles[this.activeTool] || 'Design';
    }
  };

  Customizer.prototype.refreshActivePanel = function () {
    if (this.activeTool === 'color') {
      this.renderColorPanel();
      return;
    }

    if (this.activeTool === 'uploads') {
      this.renderUploadsPanel();
      return;
    }

    if (this.activeTool === 'text') {
      this.renderTextPanel();
      return;
    }

    this.renderDesignPanel();
  };

  Customizer.prototype.updateBarStatus = function () {
    if (!this.barStatus) return;
    this.barStatus.textContent = getCurrentColorName(this.productData) || 'Choose a color';
  };

  Customizer.prototype.getUniqueColors = function () {
    var variants = this.productData && Array.isArray(this.productData.variants)
      ? this.productData.variants
      : [];
    var colorIndex = optionIndex(this.productData, 'color');
    var seen = {};
    var colors = [];

    variants.forEach(function (variant) {
      var name = String(variant.options[colorIndex] || '').trim();
      if (!name) return;

      var key = name.toLowerCase();
      if (seen[key]) {
        if (variant.available) seen[key].available = true;
        return;
      }

      seen[key] = {
        name: name,
        variantId: String(variant.id),
        image: variant.image || '',
        available: !!variant.available
      };
      colors.push(seen[key]);
    });

    return colors;
  };

  Customizer.prototype.findVariantForColor = function (colorName) {
    var variants = this.productData && Array.isArray(this.productData.variants)
      ? this.productData.variants
      : [];
    var colorIndex = optionIndex(this.productData, 'color');
    var sizeIndex = optionIndex(this.productData, 'size');
    var current = findVariant(
      this.productData,
      getSelectedVariantId(this.productData)
    );
    var currentSize = current
      ? String(current.options[sizeIndex] || '')
      : '';
    var color = String(colorName || '').trim();
    var matches = [];
    var i;

    for (i = 0; i < variants.length; i += 1) {
      if (String(variants[i].options[colorIndex] || '').trim() !== color) continue;
      matches.push(variants[i]);
    }

    if (!matches.length) return null;

    for (i = 0; i < matches.length; i += 1) {
      if (
        currentSize &&
        String(matches[i].options[sizeIndex] || '') === currentSize &&
        matches[i].available
      ) {
        return matches[i];
      }
    }

    for (i = 0; i < matches.length; i += 1) {
      if (matches[i].available) return matches[i];
    }

    return matches[0];
  };

  Customizer.prototype.selectColor = function (colorName) {
    var variant = this.findVariantForColor(colorName);
    if (!variant) return;

    var currentId = getSelectedVariantId(this.productData);
    if (String(variant.id) === String(currentId)) {
      this.renderColorPanel();
      return;
    }

    this.productData.selectedVariantId = variant.id;
    this.productData.colorOverride = true;
    this.root.setAttribute('data-variant-id', String(variant.id));

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      if (this.standalone) url.searchParams.set('view', 'customize');
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      /* Ignore malformed URLs. */
    }

    var formInput =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('input[name="id"]');

    if (formInput) {
      formInput.value = String(variant.id);
    }

    if (this.productData.handle) {
      this.exitUrl =
        '/products/' +
        encodeURIComponent(this.productData.handle) +
        '?variant=' +
        encodeURIComponent(String(variant.id));
      this.root.setAttribute('data-blv-exit-url', this.exitUrl);
    }

    this.updateBarStatus();
    this.syncVariantGarment();
    this.renderColorPanel();
  };

  Customizer.prototype.renderColorPanel = function () {
    if (!this.designPanel) return;

    var self = this;
    var colors = this.getUniqueColors();
    var current = getCurrentColorName(this.productData);
    var html = [
      '<div class="blv-customizer__color-panel">',
      '<p class="blv-customizer__design-title">Blank color</p>',
      '<p class="blv-customizer__muted">Artwork stays in place. Pick sizes when you add to cart.</p>',
      '<div class="blv-customizer__color-grid">'
    ];

    if (!colors.length) {
      html.push('<p class="blv-customizer__muted">This blank has one color.</p>');
    }

    colors.forEach(function (color) {
      var selected = String(color.name) === String(current);
      html.push(
        '<button type="button" class="blv-customizer__color-swatch' +
          (selected ? ' is-selected' : '') +
          '" data-blv-select-color="' +
          escapeHtml(color.name) +
          '" title="' +
          escapeHtml(color.name) +
          '" aria-pressed="' +
          (selected ? 'true' : 'false') +
          '">' +
          '<span class="blv-customizer__color-chip" style="background:' +
          escapeHtml(swatchHex(color.name)) +
          ';"></span>' +
          '<span class="blv-customizer__color-label">' +
          escapeHtml(color.name) +
          '</span>' +
        '</button>'
      );
    });

    html.push('</div></div>');
    this.designPanel.innerHTML = html.join('');

    this.designPanel.querySelectorAll('[data-blv-select-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.selectColor(button.getAttribute('data-blv-select-color'));
      });
    });
  };

  Customizer.prototype.updateAddArtVisibility = function () {
    if (!this.centerAddButton || !this.editor || !this.editor.canvas) return;

    var objectCount = getDesignObjects(this.editor.canvas).length;

    this.centerAddButton.style.display = objectCount > 0 ? 'none' : '';
  };

  /* =========================================================
     DESIGN PANEL
  ========================================================= */

  Customizer.prototype.getObjectUnitsPerInch = function () {
    var units = Number(
      (this.editor && this.editor.unitsPerInch) ||
      (this.editor && this.editor.options && this.editor.options.unitsPerInch)
    );

    return isFinite(units) && units > 0
      ? units
      : UNITS_PER_INCH_FALLBACK;
  };

  Customizer.prototype.getCanvasScale = function () {
    return {
      x: Number(this.editor && this.editor.scaleX) > 0
        ? Number(this.editor.scaleX)
        : 1,
      y: Number(this.editor && this.editor.scaleY) > 0
        ? Number(this.editor.scaleY)
        : 1
    };
  };

  Customizer.prototype.getObjectDisplayName = function (obj, index) {
    if (!obj) return 'Design';

    return (
      obj.name ||
      obj.sourcePath ||
      (isTextObject(obj)
        ? (obj.text || 'Text')
        : 'Artwork ' + ((index || 0) + 1))
    );
  };

  Customizer.prototype.getObjectSizeInches = function (obj) {
    if (
      this.editor &&
      typeof this.editor.objectSizeInches === 'function'
    ) {
      return this.editor.objectSizeInches(obj);
    }

    var units = this.getObjectUnitsPerInch();
    var scale = this.getCanvasScale();

    if (!obj || !units) {
      return { width: 0, height: 0 };
    }

    return {
      width: obj.getScaledWidth() / scale.x / units,
      height: obj.getScaledHeight() / scale.y / units
    };
  };

  Customizer.prototype.getObjectLimits = function () {
    var geo = getPreviewGeometry(this.productData, this.currentView);
    var options = this.editor && this.editor.options
      ? this.editor.options
      : {};

    var minWidth = Number(
      (this.editor && this.editor.minWidthIn) ||
      options.minWidthIn ||
      geo.minWidthIn
    );
    var maxWidth = Number(
      (this.editor && this.editor.maxWidthIn) ||
      options.maxWidthIn ||
      geo.maxWidthIn
    );
    var maxHeight = Number(geo.maxHeightIn);

    if (!isFinite(minWidth) || minWidth <= 0) minWidth = 0.5;
    if (!isFinite(maxWidth) || maxWidth <= 0) maxWidth = 14;
    if (!isFinite(maxHeight) || maxHeight <= 0) maxHeight = 18;

    return {
      minWidth: minWidth,
      maxWidth: maxWidth,
      minHeight: 0.5,
      maxHeight: maxHeight,
      minAngle: isFinite(Number(options.minAngle))
        ? Number(options.minAngle)
        : -180,
      maxAngle: isFinite(Number(options.maxAngle))
        ? Number(options.maxAngle)
        : 180
    };
  };

  Customizer.prototype.updateSelectedObject = function (property, rawValue, options) {
    if (!this.editor || !this.editor.canvas) return;

    options = options || {};
    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();

    if (!isDesignObject(obj)) return;

    if (property === 'fill' || property === 'fontFamily' || property === 'text') {
      var nextValue = String(rawValue == null ? '' : rawValue);
      if (property === 'text' && !nextValue.trim()) return;
      obj.set(property, nextValue);
      if (property === 'text') obj.name = nextValue;
      obj.setCoords();
      canvas.requestRenderAll();
      this.syncCurrentViewState();
      if (!options.silent) this.renderDesignPanel();
      return;
    }

    var value = Number(rawValue);
    if (!isFinite(value)) return;

    var limits = this.getObjectLimits();
    var units = this.getObjectUnitsPerInch();
    var scale = this.getCanvasScale();

    if (property === 'width') {
      value = clamp(value, limits.minWidth, limits.maxWidth);
      obj.scaleToWidth(value * units * scale.x);
    }

    if (property === 'height') {
      value = clamp(value, limits.minHeight, limits.maxHeight);
      obj.scaleToHeight(value * units * scale.y);
    }

    if (property === 'angle') {
      value = clamp(value, limits.minAngle, limits.maxAngle);
      obj.set('angle', value);
    }

    obj.setCoords();
    canvas.requestRenderAll();

    this.syncCurrentViewState();
    if (!options.silent) this.renderDesignPanel();
  };

  Customizer.prototype.flipSelectedObject = function (axis) {
    if (!this.editor || !this.editor.canvas) return;

    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();
    if (!isDesignObject(obj)) return;

    if (axis === 'y') {
      obj.set('flipY', !obj.flipY);
    } else {
      obj.set('flipX', !obj.flipX);
    }

    obj.setCoords();
    canvas.requestRenderAll();
    this.syncCurrentViewState();
  };

  Customizer.prototype.centerSelectedObject = function () {
    if (!this.editor || !this.editor.canvas) return;

    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();
    if (!isDesignObject(obj)) return;

    var placement = this.defaultArtworkPlacement();
    var scale = this.getCanvasScale();

    obj.set({
      left: placement.cx * scale.x,
      top: placement.cy * scale.y,
      originX: 'center',
      originY: 'center'
    });
    obj.setCoords();
    canvas.requestRenderAll();
    this.syncCurrentViewState();
  };

  Customizer.prototype.moveSelectedObjectLayer = function (direction) {
    if (!this.editor || !this.editor.canvas) return;

    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();
    if (!isDesignObject(obj)) return;

    if (direction === 'forward' && typeof obj.bringForward === 'function') {
      obj.bringForward();
    } else if (typeof obj.sendBackwards === 'function') {
      obj.sendBackwards();
    }

    if (this.editor.garmentObject && typeof this.editor.garmentObject.sendToBack === 'function') {
      this.editor.garmentObject.sendToBack();
    }

    canvas.requestRenderAll();
    this.syncCurrentViewState();
    this.renderDesignPanel();
  };

  Customizer.prototype.duplicateSelectedObject = function () {
    if (!this.editor || !this.editor.canvas) return;

    var self = this;
    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();

    if (!isDesignObject(obj)) return;

    obj.clone(
      function (cloned) {
        if (!cloned) return;

        cloned.set({
          left: (Number(obj.left) || 0) + 4,
          top: (Number(obj.top) || 0) + 4,
          evented: true,
          selectable: true,
          blvUserArtwork: true,
          blvKind: obj.blvKind || 'artwork',
          blvPreviewUrl: obj.blvPreviewUrl || '',
          name: obj.name || '',
          sourcePath: obj.sourcePath || ''
        });

        cloned.setCoords();
        canvas.add(cloned);
        canvas.setActiveObject(cloned);
        canvas.requestRenderAll();

        self.syncCurrentViewState();
        self.renderDesignPanel();
        self.updateAddArtVisibility();
      },
      [
        'name',
        'sourcePath',
        'crossOrigin',
        'blvUserArtwork',
        'blvKind',
        'blvPreviewUrl'
      ]
    );
  };

  Customizer.prototype.deleteSelectedObject = function () {
    if (!this.editor || !this.editor.canvas) return;

    var canvas = this.editor.canvas;
    var obj = canvas.getActiveObject();

    if (!isDesignObject(obj)) return;

    canvas.remove(obj);
    canvas.discardActiveObject();
    canvas.requestRenderAll();

    this.syncCurrentViewState();
    this.renderDesignPanel();
    this.updateAddArtVisibility();
  };

  Customizer.prototype.renderDesignPanel = function () {
    if (!this.designPanel) return;

    if (!this.editor || !this.editor.canvas) {
      this.designPanel.innerHTML = '';
      return;
    }

    var self = this;
    var canvas = this.editor.canvas;
    var objects = getDesignObjects(canvas);

    if (!objects.length) {
      this.designPanel.innerHTML = [
        '<div class="blv-customizer__empty">',
        '<strong>Start Creating</strong>',
        '<p>Upload artwork or add text to customize this garment.</p>',
        '<div class="blv-customizer__empty-actions">',
        '<button type="button" class="blv-customizer__primary" data-blv-empty-uploads>Upload artwork</button>',
        '<button type="button" class="blv-customizer__secondary-action" data-blv-empty-text>Add text</button>',
        '</div>',
        '</div>'
      ].join('');

      var emptyUploads = this.designPanel.querySelector('[data-blv-empty-uploads]');
      var emptyText = this.designPanel.querySelector('[data-blv-empty-text]');

      if (emptyUploads) {
        emptyUploads.addEventListener('click', function () {
          self.setActiveTool('uploads');
          self.renderUploadsPanel();
        });
      }

      if (emptyText) {
        emptyText.addEventListener('click', function () {
          self.setActiveTool('text');
          self.renderTextPanel();
        });
      }

      return;
    }

    var activeObject = canvas.getActiveObject();
    var selectedObject = isDesignObject(activeObject)
      ? activeObject
      : null;

    var selectedIndex = selectedObject
      ? objects.indexOf(selectedObject)
      : -1;

    var html = [];

    if (selectedObject) {
      var selectedName = this.getObjectDisplayName(
        selectedObject,
        selectedIndex
      );
      var selectedPreview = selectedObject.blvPreviewUrl || '';
      var size = this.getObjectSizeInches(selectedObject);
      var limits = this.getObjectLimits();
      var angle = Number(selectedObject.angle) || 0;
      var selectedIsText = isTextObject(selectedObject);
      var textValue = selectedIsText ? String(selectedObject.text || '') : '';
      var textFill = String(selectedObject.fill || '#111111');
      if (/^#[0-9a-f]{3}$/i.test(textFill)) {
        textFill = '#' + textFill[1] + textFill[1] + textFill[2] + textFill[2] + textFill[3] + textFill[3];
      }
      if (!/^#[0-9a-f]{6}$/i.test(textFill)) textFill = '#111111';
      var currentFont = String(selectedObject.fontFamily || 'Arial');
      var fontOptions = TEXT_FONTS.slice();
      if (fontOptions.indexOf(currentFont) === -1) fontOptions.unshift(currentFont);

      var textControls = selectedIsText
        ? [
            '<div class="blv-customizer__text-controls">',
              '<label class="blv-customizer__transform-field">',
                '<span>Text</span>',
                '<input type="text" value="' + escapeHtml(textValue) + '" data-blv-object-text>',
              '</label>',
              '<div class="blv-customizer__transform-grid">',
                '<label class="blv-customizer__transform-field">',
                  '<span>Font</span>',
                  '<select data-blv-object-font>',
                    fontOptions.map(function (font) {
                      return (
                        '<option value="' + escapeHtml(font) + '"' +
                        (font === currentFont ? ' selected' : '') +
                        '>' + escapeHtml(font) + '</option>'
                      );
                    }).join(''),
                  '</select>',
                '</label>',
                '<label class="blv-customizer__transform-field">',
                  '<span>Color</span>',
                  '<input type="color" value="' + escapeHtml(textFill) + '" data-blv-object-fill>',
                '</label>',
              '</div>',
            '</div>'
          ].join('')
        : '';

      html.push(
        '<div class="blv-customizer__selected-editor">',
          '<div class="blv-customizer__selected-head">',
            '<span class="blv-customizer__selected-preview">',
              (selectedPreview
                ? '<img src="' + escapeHtml(selectedPreview) + '" alt="">'
                : '<span class="blv-customizer__selected-text-thumb">Tt</span>'),
            '</span>',
            '<div class="blv-customizer__selected-copy">',
              '<span class="blv-customizer__selected-kicker">Selected design</span>',
              '<strong>' + escapeHtml(selectedName) + '</strong>',
            '</div>',
          '</div>',
          textControls,
          '<div class="blv-customizer__transform-grid">',
            '<label class="blv-customizer__transform-field">',
              '<span>Width</span>',
              '<div class="blv-customizer__input-unit">',
                '<input type="number" min="' + limits.minWidth.toFixed(1) + '" max="' + limits.maxWidth.toFixed(1) + '" step="0.1" value="' + size.width.toFixed(2) + '" data-blv-object-width>',
                '<span>in</span>',
              '</div>',
            '</label>',
            '<label class="blv-customizer__transform-field">',
              '<span>Height</span>',
              '<div class="blv-customizer__input-unit">',
                '<input type="number" min="' + limits.minHeight.toFixed(1) + '" max="' + limits.maxHeight.toFixed(1) + '" step="0.1" value="' + size.height.toFixed(2) + '" data-blv-object-height>',
                '<span>in</span>',
              '</div>',
            '</label>',
          '</div>',

          '<label class="blv-customizer__transform-field blv-customizer__transform-field--rotation">',
            '<span>Rotation</span>',
            '<div class="blv-customizer__rotation-row">',
              '<input type="range" min="' + limits.minAngle + '" max="' + limits.maxAngle + '" step="1" value="' + angle.toFixed(0) + '" data-blv-object-angle-range>',
              '<div class="blv-customizer__input-unit blv-customizer__input-unit--angle">',
                '<input type="number" min="' + limits.minAngle + '" max="' + limits.maxAngle + '" step="1" value="' + angle.toFixed(0) + '" data-blv-object-angle>',
                '<span>°</span>',
              '</div>',
            '</div>',
          '</label>',

          '<p class="blv-customizer__selected-note">Width and height scale proportionally so the artwork keeps its original shape.</p>',

          '<div class="blv-customizer__object-tools">',
            '<button type="button" data-blv-object-flip="x">Flip H</button>',
            '<button type="button" data-blv-object-flip="y">Flip V</button>',
            '<button type="button" data-blv-object-center>Center</button>',
            '<button type="button" data-blv-object-layer="forward">Forward</button>',
            '<button type="button" data-blv-object-layer="backward">Back</button>',
          '</div>',

          '<div class="blv-customizer__selected-actions">',
            '<button type="button" class="blv-customizer__secondary-action" data-blv-duplicate-selected>Duplicate</button>',
            '<button type="button" class="blv-customizer__danger-action" data-blv-delete-selected>Delete</button>',
          '</div>',
        '</div>'
      );
    }

    html.push(
      '<div class="blv-customizer__design-block">',
      '<p class="blv-customizer__design-title">Design elements</p>'
    );

    objects.forEach(function (obj, index) {
      var name = self.getObjectDisplayName(obj, index);
      var preview = obj.blvPreviewUrl || '';
      var activeClass = obj === selectedObject
        ? ' is-active'
        : '';

      html.push(
        '<div class="blv-customizer__design-element' + activeClass + '">' +
          '<button type="button" class="blv-customizer__design-select" data-blv-select-object="' +
          index +
          '">' +
            '<span class="blv-customizer__design-thumb">' +
              (preview
                ? '<img src="' + escapeHtml(preview) + '" alt="">'
                : '<span class="blv-customizer__design-text-thumb">Tt</span>') +
            '</span>' +
            '<span class="blv-customizer__design-name">' +
              escapeHtml(name) +
            '</span>' +
          '</button>' +
          '<button type="button" class="blv-customizer__design-remove" data-blv-remove-object="' +
          index +
          '" aria-label="Remove ' + escapeHtml(name) + '">×</button>' +
        '</div>'
      );
    });

    html.push('</div>');

    this.designPanel.innerHTML = html.join('');

    var widthInput = this.designPanel.querySelector('[data-blv-object-width]');
    var heightInput = this.designPanel.querySelector('[data-blv-object-height]');
    var angleInput = this.designPanel.querySelector('[data-blv-object-angle]');
    var angleRange = this.designPanel.querySelector('[data-blv-object-angle-range]');
    var duplicateButton = this.designPanel.querySelector('[data-blv-duplicate-selected]');
    var deleteButton = this.designPanel.querySelector('[data-blv-delete-selected]');
    var textInput = this.designPanel.querySelector('[data-blv-object-text]');
    var fontSelect = this.designPanel.querySelector('[data-blv-object-font]');
    var fillInput = this.designPanel.querySelector('[data-blv-object-fill]');

    if (widthInput) {
      widthInput.addEventListener('change', function () {
        self.updateSelectedObject('width', widthInput.value);
      });
    }

    if (heightInput) {
      heightInput.addEventListener('change', function () {
        self.updateSelectedObject('height', heightInput.value);
      });
    }

    if (angleInput) {
      angleInput.addEventListener('change', function () {
        self.updateSelectedObject('angle', angleInput.value);
      });
    }

    if (angleRange) {
      angleRange.addEventListener('input', function () {
        if (angleInput) angleInput.value = angleRange.value;

        var obj = canvas.getActiveObject();
        if (!isDesignObject(obj)) return;

        var value = Number(angleRange.value);
        if (!isFinite(value)) return;

        var rangeLimits = self.getObjectLimits();
        value = clamp(value, rangeLimits.minAngle, rangeLimits.maxAngle);

        obj.set('angle', value);
        obj.setCoords();
        canvas.requestRenderAll();
      });

      angleRange.addEventListener('change', function () {
        self.syncCurrentViewState();
        self.renderDesignPanel();
      });
    }

    if (duplicateButton) {
      duplicateButton.addEventListener('click', function () {
        self.duplicateSelectedObject();
      });
    }

    if (deleteButton) {
      deleteButton.addEventListener('click', function () {
        self.deleteSelectedObject();
      });
    }

    if (textInput) {
      textInput.addEventListener('change', function () {
        self.updateSelectedObject('text', textInput.value, { silent: true });
      });
    }

    if (fontSelect) {
      fontSelect.addEventListener('change', function () {
        self.updateSelectedObject('fontFamily', fontSelect.value, { silent: true });
      });
    }

    if (fillInput) {
      fillInput.addEventListener('input', function () {
        self.updateSelectedObject('fill', fillInput.value, { silent: true });
      });
    }

    this.designPanel.querySelectorAll('[data-blv-object-flip]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.flipSelectedObject(button.getAttribute('data-blv-object-flip'));
      });
    });

    var centerButton = this.designPanel.querySelector('[data-blv-object-center]');
    if (centerButton) {
      centerButton.addEventListener('click', function () {
        self.centerSelectedObject();
      });
    }

    this.designPanel.querySelectorAll('[data-blv-object-layer]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.moveSelectedObjectLayer(button.getAttribute('data-blv-object-layer'));
      });
    });

    this.designPanel
      .querySelectorAll('[data-blv-select-object]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          var index = Number(button.getAttribute('data-blv-select-object'));
          var canvasObjects = getDesignObjects(canvas);
          var obj = canvasObjects[index];

          if (!obj) return;

          canvas.setActiveObject(obj);
          canvas.requestRenderAll();
          self.renderDesignPanel();
        });
      });

    this.designPanel
      .querySelectorAll('[data-blv-remove-object]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          var index = Number(button.getAttribute('data-blv-remove-object'));
          var canvasObjects = getDesignObjects(canvas);
          var obj = canvasObjects[index];

          if (!obj) return;

          canvas.remove(obj);
          canvas.discardActiveObject();
          canvas.requestRenderAll();

          self.syncCurrentViewState();
          self.renderDesignPanel();
          self.updateAddArtVisibility();
        });
      });
  };

  /* =========================================================
     UPLOADS PANEL
  ========================================================= */

  Customizer.prototype.renderUploadsPanel = function () {
    if (!this.designPanel) return;

    var html = [
      '<div class="blv-customizer__uploads">',
      '<button type="button" class="blv-customizer__upload-action" data-blv-file-trigger>',
      '<span class="blv-customizer__upload-action-icon" aria-hidden="true">⇧</span>',
      '<span>From your device</span>',
      '</button>',
      '<input type="file" accept=".png,.jpg,.jpeg,.webp,.svg" hidden data-blv-file-input>',
      '<p class="blv-customizer__upload-help">PNG, JPG, WEBP or SVG. Use production-ready artwork whenever possible.</p>',
      '<p class="blv-customizer__upload-title">Your files</p>',
      '<div class="blv-customizer__upload-grid">'
    ];

    if (!this.savedUploads.length) {
      html.push('<p class="blv-customizer__muted">No uploads yet.</p>');
    } else {
      this.savedUploads.forEach(function (item, index) {
        html.push(
          '<button type="button" class="blv-customizer__upload-tile" data-blv-add-upload="' +
            index +
            '">' +
            '<span class="blv-customizer__upload-preview">' +
              '<img src="' + escapeHtml(item.preview) + '" alt="">' +
            '</span>' +
            '<span class="blv-customizer__upload-name">' +
              escapeHtml(item.name) +
            '</span>' +
          '</button>'
        );
      });
    }

    html.push('</div>');
    html.push('</div>');

    this.designPanel.innerHTML = html.join('');

    this.bindUploadsPanel();
  };

  Customizer.prototype.bindUploadsPanel = function () {
    var self = this;

    var trigger = this.designPanel.querySelector('[data-blv-file-trigger]');
    var input = this.designPanel.querySelector('[data-blv-file-input]');

    if (trigger && input) {
      trigger.addEventListener('click', function () {
        input.click();
      });

      input.addEventListener('change', function (event) {
        var files = Array.prototype.slice.call(event.target.files || []);
        if (!files.length) return;

        files.forEach(function (file) {
          self.storeUpload(file, function (storedItem) {
            self.addArtworkToCanvas(storedItem);
            self.renderUploadsPanel();
            self.updateAddArtVisibility();
          });
        });

        input.value = '';
      });
    }

    this.designPanel
      .querySelectorAll('[data-blv-add-upload]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          var index = Number(button.getAttribute('data-blv-add-upload'));
          var item = self.savedUploads[index];
          if (!item) return;

          self.addArtworkToCanvas(item);
        });
      });
  };

  Customizer.prototype.storeUpload = function (file, callback) {
    var self = this;
    var reader = new FileReader();

    reader.onload = function (event) {
      var result = event.target.result;

      var stored = {
        name: file.name,
        type: file.type,
        size: file.size,
        raw: file,
        dataUrl: result,
        preview: result
      };

      self.savedUploads.push(stored);

      if (typeof callback === 'function') {
        callback(stored);
      }
    };

    reader.readAsDataURL(file);
  };

  Customizer.prototype.defaultArtworkPlacement = function () {
    var geo = getPreviewGeometry(this.productData, this.currentView);
    var placement = geo.placement || {};
    var widthIn = 4;

    return {
      cx: Number(placement.cx) > 0 ? Number(placement.cx) * 100 : 50,
      cy: Number(placement.cy) > 0 ? Number(placement.cy) * 100 : 46,
      widthIn: widthIn
    };
  };

  Customizer.prototype.addArtworkToCanvas = function (uploadItem) {
    if (!this.editor || !this.editor.canvas || !uploadItem) return;

    var self = this;
    var canvas = this.editor.canvas;
    var source = uploadItem.dataUrl;
    var placement = this.defaultArtworkPlacement();
    var units = this.getObjectUnitsPerInch();
    var scale = this.getCanvasScale();

    function finalizeObject(obj) {
      obj.set({
        left: placement.cx * scale.x,
        top: placement.cy * scale.y,
        originX: 'center',
        originY: 'center',
        cornerStyle: 'circle',
        transparentCorners: false,
        name: uploadItem.name,
        sourcePath: uploadItem.name,
        blvUserArtwork: true,
        blvKind: 'artwork',
        blvPreviewUrl: uploadItem.preview || source
      });

      var targetWidth = placement.widthIn * units * scale.x;
      if (obj.width) {
        obj.scaleToWidth(targetWidth);
      }

      canvas.add(obj);
      canvas.setActiveObject(obj);
      canvas.requestRenderAll();

      self.setActiveTool('design');
      self.syncCurrentViewState();
      self.renderDesignPanel();
      self.updateAddArtVisibility();
    }

    if (uploadItem.type === 'image/svg+xml' || /\.svg$/i.test(uploadItem.name)) {
      fabric.loadSVGFromURL(source, function (objects, options) {
        var svgObj = fabric.util.groupSVGElements(objects, options);
        finalizeObject(svgObj);
      });
      return;
    }

    fabric.Image.fromURL(
      source,
      function (img) {
        finalizeObject(img);
      },
      { crossOrigin: 'anonymous' }
    );
  };

  /* =========================================================
     TEXT PANEL
  ========================================================= */

  Customizer.prototype.renderTextPanel = function () {
    if (!this.designPanel) return;

    this.designPanel.innerHTML = [
      '<div class="blv-customizer__panel-section">',
      '<div class="blv-customizer__panel-title">Add text</div>',
      '<label class="blv-customizer__field">',
      '<span>Text</span>',
      '<input type="text" data-blv-text-value placeholder="Enter your text">',
      '</label>',
      '<button type="button" class="blv-customizer__primary" data-blv-add-text>',
      'Add text',
      '</button>',
      '<p class="blv-customizer__muted">After adding, use Design to change font and color.</p>',
      '</div>'
    ].join('');

    this.bindTextPanel();
  };

  Customizer.prototype.bindTextPanel = function () {
    var self = this;
    var input = this.designPanel.querySelector('[data-blv-text-value]');
    var button = this.designPanel.querySelector('[data-blv-add-text]');

    if (!input || !button) return;

    button.addEventListener('click', function () {
      var value = (input.value || '').trim();
      if (!value || !self.editor || !self.editor.canvas) return;

      var canvas = self.editor.canvas;
      var placement = self.defaultArtworkPlacement();
      var units = self.getObjectUnitsPerInch();
      var scale = self.getCanvasScale();

      var textbox = new fabric.Textbox(value, {
        left: placement.cx * scale.x,
        top: placement.cy * scale.y,
        originX: 'center',
        originY: 'center',
        fontSize: 28,
        fill: '#111',
        fontFamily: 'Arial',
        cornerStyle: 'circle',
        transparentCorners: false,
        name: value,
        blvUserArtwork: true,
        blvKind: 'text',
        blvPreviewUrl: ''
      });

      textbox.scaleToWidth(placement.widthIn * units * scale.x);

      canvas.add(textbox);
      canvas.setActiveObject(textbox);
      canvas.requestRenderAll();

      self.setActiveTool('design');
      self.syncCurrentViewState();
      self.renderDesignPanel();
      self.updateAddArtVisibility();
    });
  };

  /* =========================================================
     ORDER SHEET / CART
  ========================================================= */

  Customizer.prototype.initOrderSheet = function () {
    var self = this;

    if (!this.orderSheet) return;

    this.root.querySelectorAll('[data-blv-open-order]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        self.openOrderSheet();
      });
    });

    this.orderSheet.querySelectorAll('[data-blv-order-close], [data-blv-order-keep]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        self.closeOrderSheet();
      });
    });

    var addToCart = this.orderSheet.querySelector('[data-blv-order-atc]');
    if (addToCart) {
      addToCart.addEventListener('click', function (event) {
        event.preventDefault();
        self.addOrderToCart();
      });
    }

    var jumpLine = this.orderSheet.querySelector('[data-blv-jump-line]');
    if (jumpLine) {
      jumpLine.addEventListener('change', function () {
        self.updateOrderTotal();
      });
    }

    this.orderSheet.querySelectorAll('[data-blv-order-production]').forEach(function (production) {
      production.addEventListener('click', function (event) {
        event.preventDefault();
        self.startProductionRun();
      });
    });
  };

  Customizer.prototype.isOrderSheetOpen = function () {
    return !!(this.orderSheet && !this.orderSheet.hidden);
  };

  Customizer.prototype.getColorVariants = function (colorName) {
    var variants = this.productData && Array.isArray(this.productData.variants)
      ? this.productData.variants
      : [];
    var color = colorName != null && String(colorName).trim() !== ''
      ? String(colorName).trim()
      : getCurrentColorName(this.productData);
    var colorIndex = optionIndex(this.productData, 'color');
    var sizeIndex = optionIndex(this.productData, 'size');

    var matches = variants.filter(function (variant) {
      if (!color) return true;
      return String(variant.options[colorIndex] || '').trim() === color;
    });

    matches.sort(function (a, b) {
      var as = SIZE_ORDER.indexOf(String(a.options[sizeIndex] || '').toUpperCase());
      var bs = SIZE_ORDER.indexOf(String(b.options[sizeIndex] || '').toUpperCase());
      if (as === -1 && bs === -1) return 0;
      if (as === -1) return 1;
      if (bs === -1) return -1;
      return as - bs;
    });

    return matches.length ? matches : variants.slice();
  };

  Customizer.prototype.getDesignedUnitPrice = function () {
    var raw = Number(this.productData && this.productData.designedPrice);
    if (!raw || raw < 0) return 4000;
    if (raw < 500) return Math.round(raw * 100);
    if (raw > 100000) return Math.round(raw / 100);
    return Math.round(raw);
  };

  Customizer.prototype.getOrderVariant = function (row) {
    var sizeIndex = optionIndex(this.productData, 'size');
    var variants = this.getColorVariants(row && row.color);

    return variants.filter(function (variant) {
      return String(variant.options[sizeIndex] || '') === String(row.size || '');
    })[0] || null;
  };

  Customizer.prototype.usedSizesForColor = function (color, exceptRowId) {
    return this.orderRows.filter(function (row) {
      if (exceptRowId && row.id === exceptRowId) return false;
      return String(row.color || '') === String(color || '');
    }).map(function (row) {
      return String(row.size);
    });
  };

  Customizer.prototype.nextAvailableSize = function (color, exceptRowId) {
    var sizeIndex = optionIndex(this.productData, 'size');
    var used = this.usedSizesForColor(color, exceptRowId);

    return this.getColorVariants(color).filter(function (variant) {
      return (
        variant.available &&
        used.indexOf(String(variant.options[sizeIndex] || '')) === -1
      );
    })[0] || null;
  };

  Customizer.prototype.openOrderSheet = function () {
    var color = getCurrentColorName(this.productData) || 'Default';
    var sizeIndex = optionIndex(this.productData, 'size');
    var first = this.getColorVariants(color).filter(function (variant) {
      return variant.available;
    })[0] || this.getColorVariants(color)[0];

    this.orderRows = first
      ? [{
          id: nextOrderRowId(),
          color: color,
          size: first.options[sizeIndex] || first.title,
          qty: 1
        }]
      : [];
    this.orderDraft = { color: '', size: '' };

    this.setOrderError('');
    var jumpLine = this.orderSheet.querySelector('[data-blv-jump-line]');
    if (jumpLine) jumpLine.checked = false;
    this.renderOrderRows();
    this.orderSheet.hidden = false;
    document.body.classList.add('blv-customizer-order-open');
  };

  Customizer.prototype.closeOrderSheet = function () {
    if (!this.orderSheet) return;
    this.orderSheet.hidden = true;
    document.body.classList.remove('blv-customizer-order-open');
  };

  Customizer.prototype.commitOrderVariant = function (color, size) {
    var nextColor = String(color || '').trim();
    var nextSize = String(size || '').trim();

    if (!nextColor || !nextSize) return;

    var exists = this.orderRows.some(function (row) {
      return String(row.color) === nextColor && String(row.size) === nextSize;
    });

    if (exists) {
      this.setOrderError('That color and size is already in the order.');
      return;
    }

    var variant = this.getOrderVariant({ color: nextColor, size: nextSize });
    if (!variant || !variant.available) {
      this.setOrderError('That size is not available for this color.');
      return;
    }

    this.setOrderError('');
    this.orderRows.push({
      id: nextOrderRowId(),
      color: nextColor,
      size: nextSize,
      qty: 1
    });
    this.orderDraft = { color: '', size: '' };
    this.renderOrderRows();
  };

  Customizer.prototype.removeOrderRow = function (rowId) {
    if (this.orderRows.length <= 1) return;
    this.orderRows = this.orderRows.filter(function (row) {
      return row.id !== rowId;
    });
    this.renderOrderRows();
  };

  Customizer.prototype.renderOrderRows = function () {
    if (!this.orderRowsEl) return;

    var self = this;
    var sizeIndex = optionIndex(this.productData, 'size');
    var colors = this.getUniqueColors();

    this.orderRowsEl.innerHTML = this.orderRows.map(function (row) {
      var variant = self.getOrderVariant(row);
      var price = self.getDesignedUnitPrice();
      var qty = Math.max(1, Number(row.qty) || 1);
      var usedSizes = self.usedSizesForColor(row.color, row.id);
      var sizeOptions = self.getColorVariants(row.color).map(function (item) {
        var size = item.options[sizeIndex] || item.title;
        var taken = usedSizes.indexOf(String(size)) !== -1;
        return (
          '<option value="' + escapeHtml(size) + '"' +
          (String(size) === String(row.size) ? ' selected' : '') +
          (taken || !item.available ? ' disabled' : '') +
          '>' +
          escapeHtml(size) +
          (item.available ? '' : ' — sold out') +
          '</option>'
        );
      }).join('');
      var colorOptions = (colors.length ? colors : [{ name: row.color || 'Default' }]).map(function (color) {
        return (
          '<option value="' + escapeHtml(color.name) + '"' +
          (String(color.name) === String(row.color) ? ' selected' : '') +
          '>' +
          escapeHtml(color.name) +
          '</option>'
        );
      }).join('');

      return (
        '<div class="blv-customizer__order-row" data-order-row="' + row.id + '">' +
          '<label class="blv-customizer__order-color">' +
            '<span class="visually-hidden">Color</span>' +
            '<select data-blv-order-color>' + colorOptions + '</select>' +
          '</label>' +
          '<label>' +
            '<span class="visually-hidden">Size</span>' +
            '<select data-blv-order-size>' + sizeOptions + '</select>' +
          '</label>' +
          '<label class="blv-customizer__order-qty">' +
            '<span class="visually-hidden">Quantity</span>' +
            '<input type="number" min="1" step="1" value="' + qty + '" data-blv-order-qty>' +
          '</label>' +
          '<span>' + formatMoney(price, self.currency) + '</span>' +
          '<span>' + formatMoney(price * qty, self.currency) + '</span>' +
          '<button type="button" class="blv-customizer__order-remove" data-blv-order-remove aria-label="Remove size"' +
          (self.orderRows.length <= 1 ? ' disabled' : '') +
          '>×</button>' +
        '</div>'
      );
    }).join('');

    var draft = this.orderDraft || { color: '', size: '' };
    var canAddMore = colors.some(function (color) {
      return !!self.nextAvailableSize(color.name);
    });

    if (canAddMore) {
      var draftSizeIndex = optionIndex(this.productData, 'size');
      var draftColorOptions = colors.map(function (color) {
        var remaining = self.nextAvailableSize(color.name);
        return (
          '<option value="' + escapeHtml(color.name) + '"' +
          (String(color.name) === String(draft.color) ? ' selected' : '') +
          (remaining ? '' : ' disabled') +
          '>' +
          escapeHtml(color.name) +
          '</option>'
        );
      }).join('');
      var draftSizeOptions = '';

      if (draft.color) {
        var usedDraftSizes = self.usedSizesForColor(draft.color);
        draftSizeOptions = self.getColorVariants(draft.color).map(function (item) {
          var size = item.options[draftSizeIndex] || item.title;
          var taken = usedDraftSizes.indexOf(String(size)) !== -1;
          return (
            '<option value="' + escapeHtml(size) + '"' +
            (String(size) === String(draft.size) ? ' selected' : '') +
            (taken || !item.available ? ' disabled' : '') +
            '>' +
            escapeHtml(size) +
            (item.available ? '' : ' — sold out') +
            '</option>'
          );
        }).join('');
      }

      this.orderRowsEl.innerHTML +=
        '<div class="blv-customizer__order-row blv-customizer__order-row--draft" data-blv-order-draft>' +
          '<label class="blv-customizer__order-color">' +
            '<span class="visually-hidden">Add another color</span>' +
            '<select data-blv-order-draft-color>' +
              '<option value="">Add another variant...</option>' +
              draftColorOptions +
            '</select>' +
          '</label>' +
          '<label>' +
            '<span class="visually-hidden">Size</span>' +
            '<select data-blv-order-draft-size' + (draft.color ? '' : ' disabled') + '>' +
              '<option value="">Select...</option>' +
              draftSizeOptions +
            '</select>' +
          '</label>' +
          '<input type="number" value="1" disabled aria-label="Quantity">' +
          '<span class="blv-customizer__order-muted">—</span>' +
          '<span class="blv-customizer__order-muted">—</span>' +
          '<span></span>' +
        '</div>';
    }

    this.orderRowsEl.querySelectorAll('[data-order-row]').forEach(function (node) {
      var rowId = node.getAttribute('data-order-row');
      var row = self.orderRows.filter(function (item) {
        return item.id === rowId;
      })[0];
      if (!row) return;

      var colorSelect = node.querySelector('[data-blv-order-color]');
      var sizeSelect = node.querySelector('[data-blv-order-size]');
      var qtyInput = node.querySelector('[data-blv-order-qty]');
      var remove = node.querySelector('[data-blv-order-remove]');

      if (colorSelect) {
        colorSelect.addEventListener('change', function () {
          var nextColor = colorSelect.value;
          var sizeIndexInner = optionIndex(self.productData, 'size');
          var used = self.usedSizesForColor(nextColor, row.id);
          var variants = self.getColorVariants(nextColor);
          var keepSize = variants.some(function (item) {
            return (
              item.available &&
              String(item.options[sizeIndexInner] || '') === String(row.size) &&
              used.indexOf(String(row.size)) === -1
            );
          });

          row.color = nextColor;

          if (!keepSize) {
            var next = self.nextAvailableSize(nextColor, row.id);
            if (next) {
              row.size = next.options[sizeIndexInner] || next.title;
            } else {
              self.setOrderError('Every available size for that color is already in the order.');
            }
          } else {
            self.setOrderError('');
          }

          self.renderOrderRows();
        });
      }

      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          row.size = sizeSelect.value;
          self.renderOrderRows();
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          row.qty = Math.max(1, Math.floor(Number(qtyInput.value) || 1));
          self.renderOrderRows();
        });
      }

      if (remove) {
        remove.addEventListener('click', function () {
          self.removeOrderRow(rowId);
        });
      }
    });

    var draftColor = this.orderRowsEl.querySelector('[data-blv-order-draft-color]');
    var draftSize = this.orderRowsEl.querySelector('[data-blv-order-draft-size]');

    if (draftColor) {
      draftColor.addEventListener('change', function () {
        self.orderDraft = self.orderDraft || { color: '', size: '' };
        self.orderDraft.color = draftColor.value;
        self.orderDraft.size = '';
        self.setOrderError('');
        self.renderOrderRows();
      });
    }

    if (draftSize) {
      draftSize.addEventListener('change', function () {
        self.orderDraft = self.orderDraft || { color: '', size: '' };
        self.orderDraft.size = draftSize.value;
        if (self.orderDraft.color && self.orderDraft.size) {
          self.commitOrderVariant(self.orderDraft.color, self.orderDraft.size);
        }
      });
    }

    this.updateOrderTotal();
  };

  Customizer.prototype.getOrderItems = function () {
    var self = this;

    return this.orderRows.map(function (row) {
      var variant = self.getOrderVariant(row);
      var qty = Math.max(1, Math.floor(Number(row.qty) || 1));

      return {
        row: row,
        variant: variant,
        quantity: qty,
        price: self.getDesignedUnitPrice()
      };
    }).filter(function (item) {
      return item.variant && item.variant.available && item.quantity > 0;
    });
  };

  Customizer.prototype.isJumpLineSelected = function () {
    var input = this.orderSheet && this.orderSheet.querySelector('[data-blv-jump-line]');
    return !!(input && input.checked && this.jumpVariantId);
  };

  Customizer.prototype.updateOrderTotal = function () {
    var totalEl = this.root.querySelector('[data-blv-order-total]');
    var items = this.getOrderItems();
    var total = items.reduce(function (sum, item) {
      return sum + item.price * item.quantity;
    }, 0);

    if (this.isJumpLineSelected()) {
      total += this.jumpPriceCents || 2000;
    }

    if (totalEl) {
      totalEl.textContent = formatMoney(total, this.currency);
    }

    var addButton = this.orderSheet && this.orderSheet.querySelector('[data-blv-order-atc]');
    if (addButton) {
      addButton.disabled = items.length === 0 || this.orderSubmitting;
    }
  };

  Customizer.prototype.setOrderError = function (message) {
    var el = this.root.querySelector('[data-blv-order-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  Customizer.prototype.getDesignedSides = function () {
    this.syncCurrentViewState();

    var labels = {
      front: 'Front',
      back: 'Back',
      'left-chest': 'Left Chest'
    };

    return ['front', 'back', 'left-chest'].filter(function (view) {
      return (this.viewState[view] || []).length > 0;
    }, this).map(function (view) {
      return labels[view];
    });
  };

  Customizer.prototype.setOrderBusy = function (label) {
    var addButton = this.orderSheet && this.orderSheet.querySelector('[data-blv-order-atc]');
    if (!addButton) return;

    if (!this._orderAtcLabel) {
      this._orderAtcLabel = addButton.textContent;
    }

    addButton.textContent = label || this._orderAtcLabel || 'Add to cart';
  };

  Customizer.prototype.collectUsedArtwork = function () {
    var labels = {
      front: 'Front',
      back: 'Back',
      'left-chest': 'Left Chest'
    };
    var usage = {};

    ['front', 'back', 'left-chest'].forEach(function (view) {
      (this.viewState[view] || []).forEach(function (obj) {
        var key = obj.sourcePath || obj.name;
        if (!key || obj.blvKind === 'text') return;
        if (!usage[key]) usage[key] = [];
        if (usage[key].indexOf(labels[view]) === -1) {
          usage[key].push(labels[view]);
        }
      });
    }, this);

    return this.savedUploads.filter(function (item) {
      return usage[item.name];
    }).map(function (item) {
      return {
        name: item.name,
        type: item.type || 'application/octet-stream',
        size: item.size || (item.raw && item.raw.size) || 0,
        raw: item.raw || null,
        dataUrl: item.dataUrl || '',
        sides: usage[item.name]
      };
    });
  };

  Customizer.prototype.dataUrlToBlob = function (dataUrl, fallbackType) {
    if (!dataUrl) return null;

    try {
      var parts = String(dataUrl).split(',');
      var mimeMatch = parts[0] && parts[0].match(/:(.*?);/);
      var mime = (mimeMatch && mimeMatch[1]) || fallbackType || 'image/jpeg';
      var binary = atob(parts[1] || '');
      var bytes = new Uint8Array(binary.length);
      var i;

      for (i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
      }

      return new Blob([bytes], { type: mime });
    } catch (error) {
      return null;
    }
  };

  Customizer.prototype.ensureUploadCaps = function () {
    return Promise.resolve({});
  };

  Customizer.prototype.putStorageObject = function (blob, meta) {
    var endpoint = this.uploadEndpoint || '/apps/blvnks/dtf';
    var name = (meta && meta.name) || 'artwork.bin';
    var type = (meta && meta.type) || blob.type || 'application/octet-stream';
    var sides = (meta && meta.sides) || [];

    return fetch(endpoint + '/upload-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        filename: name,
        mimeType: type,
        size: blob.size
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data.ok) {
          throw new Error(data.message || 'Artwork upload service is unavailable');
        }
        return data;
      });
    }).then(function (grant) {
      var body;
      var headers = {};
      if (grant.parameters && grant.parameters.length) {
        body = new FormData();
        grant.parameters.forEach(function (param) {
          body.append(param.name, param.value);
        });
        body.append('file', blob, name);
      } else {
        body = blob;
        headers['Content-Type'] = type;
      }
      return fetch(grant.url, {
        method: grant.method || 'POST',
        headers: headers,
        body: body
      }).then(function (response) {
        if (!response.ok) throw new Error('Upload failed for ' + name);
        return fetch(endpoint + '/complete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            resourceUrl: grant.resourceUrl,
            filename: name,
            mimeType: type,
            kind: 'dtg'
          })
        });
      });
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data.ok || !data.url) {
          throw new Error(data.message || 'Artwork upload service is unavailable');
        }
        return {
          name: name,
          type: type,
          url: data.url,
          storagePath: data.id || '',
          sides: sides
        };
      });
    });
  };

  Customizer.prototype.uploadArtworkFiles = function (files) {
    var self = this;

    if (!files.length) {
      return Promise.resolve([]);
    }

    return Promise.all(files.map(function (file) {
      var blob = file.raw || self.dataUrlToBlob(file.dataUrl, file.type);
      if (!blob) {
        throw new Error('Could not read ' + file.name + '. Please re-upload it and try again.');
      }

      return self.putStorageObject(blob, file);
    }));
  };

  Customizer.prototype.uploadPlacementProofs = function (proofs) {
    var self = this;
    var views = ['front', 'back', 'left-chest'];

    return this.ensureUploadCaps().then(function () {
      return Promise.all(views.map(function (view) {
        var proof = proofs[view];
        if (!proof || !proof.blob) return null;

        return self.putStorageObject(proof.blob, {
          name: 'proof-' + view + '.jpg',
          type: 'image/jpeg'
        }).then(function (stored) {
          proof.url = stored.url;
          proof.storagePath = stored.storagePath;
        }).catch(function (error) {
          console.warn('[blvnks-customizer] Could not upload ' + view + ' proof', error);
        });
      }));
    }).then(function () {
      return proofs;
    }).catch(function (error) {
      console.warn('[blvnks-customizer] Placement proof upload skipped', error);
      return proofs;
    });
  };

  Customizer.prototype.showViewForCapture = function (view) {
    var self = this;

    this.currentView = view;
    this.clearDesignObjects();
    this.applyViewGeometry(view);

    return this.syncVariantGarment().then(function () {
      return self.loadViewState(view, { keepSuspended: true });
    }).then(function () {
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      });
    });
  };

  Customizer.prototype.captureViewProof = function () {
    if (!this.editor || !this.editor.canvas) {
      return { dataUrl: '', blob: null };
    }

    var canvas = this.editor.canvas;
    var garment = this.editor.garmentObject;
    var dataUrl = '';

    canvas.discardActiveObject();

    if (garment) garment.excludeFromExport = false;

    try {
      var width = canvas.getWidth() || 1;
      dataUrl = canvas.toDataURL({
        format: 'jpeg',
        quality: 0.72,
        multiplier: Math.min(1, 360 / width)
      });
    } catch (error) {
      console.warn('[blvnks-customizer] Could not capture placement preview', error);
    }

    if (garment) garment.excludeFromExport = true;
    canvas.requestRenderAll();

    return {
      dataUrl: dataUrl,
      blob: this.dataUrlToBlob(dataUrl, 'image/jpeg')
    };
  };

  Customizer.prototype.applyColorForCapture = function (colorName) {
    var variant = this.findVariantForColor(colorName);

    if (variant && this.productData) {
      this.productData.selectedVariantId = variant.id;
      this.productData.colorOverride = true;
    }

    return this.syncVariantGarment();
  };

  Customizer.prototype.captureViewsOnCurrentGarment = function () {
    var self = this;
    var views = ['front', 'back', 'left-chest'];
    var proofs = {};

    return views.reduce(function (chain, view) {
      return chain.then(function () {
        return self.showViewForCapture(view);
      }).then(function () {
        proofs[view] = self.captureViewProof();
      });
    }, Promise.resolve()).then(function () {
      return proofs;
    });
  };

  Customizer.prototype.capturePlacementProofsByColor = function (colors) {
    var self = this;
    var startView = this.currentView;
    var startVariantId = this.productData && this.productData.selectedVariantId;
    var startOverride = !!(this.productData && this.productData.colorOverride);
    var list = colors && colors.length
      ? colors.slice()
      : [getCurrentColorName(this.productData) || 'Default'];
    var byColor = {};

    this.syncCurrentViewState();
    this._suspendCanvasSync = true;

    function restore() {
      if (self.productData) {
        self.productData.selectedVariantId = startVariantId;
        self.productData.colorOverride = startOverride;
      }

      return self.showViewForCapture(startView).then(function () {
        self._suspendCanvasSync = false;
        self.updateViewButtons();
        self.refreshActivePanel();
        self.updateAddArtVisibility();
      });
    }

    return list.reduce(function (chain, color) {
      return chain.then(function () {
        return self.applyColorForCapture(color);
      }).then(function () {
        return self.captureViewsOnCurrentGarment();
      }).then(function (proofs) {
        byColor[color] = proofs;
      });
    }, Promise.resolve()).then(function () {
      return restore().then(function () {
        return byColor;
      });
    }).catch(function (error) {
      return restore().then(function () {
        throw error;
      });
    });
  };

  Customizer.prototype.uploadPlacementProofsByColor = function (proofsByColor) {
    var self = this;
    var colors = Object.keys(proofsByColor || {});

    return Promise.all(colors.map(function (color) {
      return self.uploadPlacementProofs(proofsByColor[color]);
    })).then(function () {
      return proofsByColor;
    });
  };

  Customizer.prototype.proofsForColor = function (proofsByColor, color) {
    if (!proofsByColor) return null;
    if (proofsByColor[color]) return proofsByColor[color];

    var key = String(color || '').toLowerCase();
    var names = Object.keys(proofsByColor);
    var i;

    for (i = 0; i < names.length; i += 1) {
      if (names[i].toLowerCase() === key) return proofsByColor[names[i]];
    }

    return names.length ? proofsByColor[names[0]] : null;
  };

  Customizer.prototype.capturePlacementProofs = function () {
    var color = getCurrentColorName(this.productData) || 'Default';
    return this.capturePlacementProofsByColor([color]).then(function (byColor) {
      return byColor[color] || byColor[Object.keys(byColor)[0]] || {};
    });
  };

  Customizer.prototype.storeLocalPreviews = function (designId, proofsByColor) {
    var byColor = {};
    var first = null;

    Object.keys(proofsByColor || {}).forEach(function (color) {
      var proofs = proofsByColor[color] || {};
      var map = {
        front: proofs.front && proofs.front.dataUrl ? proofs.front.dataUrl : '',
        back: proofs.back && proofs.back.dataUrl ? proofs.back.dataUrl : '',
        'left-chest': proofs['left-chest'] && proofs['left-chest'].dataUrl
          ? proofs['left-chest'].dataUrl
          : ''
      };

      byColor[String(color).toLowerCase()] = map;
      if (!first) first = map;
    });

    var stored = first
      ? {
          front: first.front,
          back: first.back,
          'left-chest': first['left-chest'],
          byColor: byColor
        }
      : { byColor: byColor };

    try {
      localStorage.setItem(
        'blvnks.designPreview.' + designId,
        JSON.stringify(stored)
      );
    } catch (error) {
      console.warn('[blvnks-customizer] Could not persist design preview', error);
    }
  };

  Customizer.prototype.buildDesignProperties = function (designId, sides, files, proofs) {
    var color = getCurrentColorName(this.productData) || '';
    var properties = {
      '_Design ID': designId,
      '_Designed price': String(this.getDesignedUnitPrice()),
      Designed: sides.length ? 'Yes' : 'Blank',
      Color: color,
      'Design sides': sides.length ? sides.join(', ') : 'None'
    };

    if (files.length) {
      properties.Artwork = files.map(function (file) {
        return file.name;
      }).join(', ');
    }

    function clip(value) {
      var text = String(value || '');
      return text.length > 255 ? text.slice(0, 255) : text;
    }

    files.forEach(function (file, index) {
      var n = String(index + 1);
      if (file.url) properties['_File ' + n] = clip(file.url);
      if (file.name) properties['_File ' + n + ' name'] = clip(file.name);
      if (file.storagePath && String(file.storagePath).indexOf('gid://shopify/') === 0) {
        properties['_File ' + n + ' ID'] = file.storagePath;
      }
      if (file.sides && file.sides.length) {
        properties['_File ' + n + ' sides'] = file.sides.join(', ');
      }
    });

    if (proofs.front && proofs.front.url) properties['_Proof Front'] = clip(proofs.front.url);
    if (proofs.back && proofs.back.url) properties['_Proof Back'] = clip(proofs.back.url);
    if (proofs['left-chest'] && proofs['left-chest'].url) {
      properties['_Proof Left Chest'] = clip(proofs['left-chest'].url);
    }
    if (proofs.front && proofs.front.storagePath) properties['_Proof Front ID'] = proofs.front.storagePath;
    if (proofs.back && proofs.back.storagePath) properties['_Proof Back ID'] = proofs.back.storagePath;
    if (proofs['left-chest'] && proofs['left-chest'].storagePath) {
      properties['_Proof Left Chest ID'] = proofs['left-chest'].storagePath;
    }

    try {
      sessionStorage.setItem(
        'blvnks.customizerDesign.' + designId,
        JSON.stringify({
          id: designId,
          handle: this.productData && this.productData.handle,
          color: color,
          profile: this.productData && this.productData.profile,
          sides: sides,
          files: files.map(function (file) {
            return {
              name: file.name,
              url: file.url || '',
              storagePath: file.storagePath || '',
              sides: file.sides || []
            };
          })
        })
      );
    } catch (error) {
      console.warn('[blvnks-customizer] Could not persist design summary', error);
    }

    return properties;
  };

  Customizer.prototype.addOrderToCart = function () {
    var self = this;
    var items = this.getOrderItems();

    if (this.orderSubmitting) return;

    if (!items.length) {
      this.setOrderError('Choose a size and quantity first.');
      return;
    }

    this.syncCurrentViewState();

    var designId = 'blv_' + Date.now().toString(36);
    var sides = this.getDesignedSides();
    var files = this.collectUsedArtwork();
    var hasPlacedArtwork = ['front', 'back', 'left-chest'].some(function (view) {
      return (this.viewState[view] || []).some(function (obj) {
        return obj.blvKind !== 'text' && (obj.sourcePath || obj.name);
      });
    }, this);

    if (!sides.length) {
      this.setOrderError('Add artwork or text before checking out. Blank garments are ordered from the product page.');
      return;
    }

    if (hasPlacedArtwork && !files.length) {
      this.setOrderError('Your artwork files are no longer available in this session. Please re-upload them and try again.');
      return;
    }

    this.orderSubmitting = true;
    this.updateOrderTotal();
    this.setOrderError('');
    this.setOrderBusy('Rendering previews...');

    var orderColors = [];
    var seenColors = {};
    items.forEach(function (item) {
      var color = (item.row && item.row.color) || getCurrentColorName(self.productData) || 'Default';
      if (item.row && !item.row.color) item.row.color = color;
      var key = String(color).toLowerCase();
      if (seenColors[key]) return;
      seenColors[key] = true;
      orderColors.push(color);
    });

    this.capturePlacementProofsByColor(orderColors)
      .then(function (proofsByColor) {
        self.storeLocalPreviews(designId, proofsByColor);
        self.setOrderBusy('Saving artwork...');

        var fileUploads = files.length
          ? self.uploadArtworkFiles(files)
          : Promise.resolve([]);

        return fileUploads.then(function (uploaded) {
          return self.uploadPlacementProofsByColor(proofsByColor).then(function (proofsWithUrls) {
            return { uploaded: uploaded, proofsByColor: proofsWithUrls };
          });
        });
      })
      .then(function (pack) {
        self.setOrderBusy('Adding to cart...');

        var properties = self.buildDesignProperties(
          designId,
          sides,
          pack.uploaded,
          self.proofsForColor(pack.proofsByColor, orderColors[0]) || {}
        );

        var payloadItems = items.map(function (item) {
          var proofs = self.proofsForColor(
            pack.proofsByColor,
            item.row && item.row.color
          ) || {};
          var lineProperties = {};
          Object.keys(properties).forEach(function (key) {
            lineProperties[key] = properties[key];
          });
          if (item.row && item.row.color) {
            lineProperties.Color = item.row.color;
          }
          if (proofs.front && proofs.front.url) {
            lineProperties['_Proof Front'] = proofs.front.url;
          }
          if (proofs.back && proofs.back.url) {
            lineProperties['_Proof Back'] = proofs.back.url;
          }
          if (proofs['left-chest'] && proofs['left-chest'].url) {
            lineProperties['_Proof Left Chest'] = proofs['left-chest'].url;
          }
          if (proofs.front && proofs.front.storagePath) {
            lineProperties['_Proof Front ID'] = proofs.front.storagePath;
          }
          if (proofs.back && proofs.back.storagePath) {
            lineProperties['_Proof Back ID'] = proofs.back.storagePath;
          }
          if (proofs['left-chest'] && proofs['left-chest'].storagePath) {
            lineProperties['_Proof Left Chest ID'] = proofs['left-chest'].storagePath;
          }

          return {
            id: item.variant.id,
            quantity: item.quantity,
            properties: lineProperties
          };
        });

        var jumpId = self.jumpVariantId;
        var addJump = self.isJumpLineSelected() && jumpId;

        var cartLookup = addJump
          ? fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
              return res.json();
            })
          : Promise.resolve({ items: [] });

        return cartLookup.then(function (cart) {
          var already = (cart.items || []).some(function (line) {
            return Number(line.variant_id) === jumpId || Number(line.id) === jumpId;
          });

          if (addJump && !already) {
            payloadItems.push({
              id: jumpId,
              quantity: 1,
              properties: { '_Jump the line': 'Yes' }
            });
          }

          return fetch(
            window.routes && window.routes.cart_add_url
              ? window.routes.cart_add_url
              : '/cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: payloadItems })
            }
          );
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(
                data.description || data.message || 'Unable to add this design to cart.'
              );
            }
            return data;
          });
        });
      })
      .then(function () {
        window.location.href = window.routes && window.routes.cart_url
          ? window.routes.cart_url
          : '/cart';
      })
      .catch(function (error) {
        console.warn('[blvnks-customizer] cart add failed', error);
        self.setOrderError(error.message || 'Unable to add this design to cart.');
        self.orderSubmitting = false;
        self.setOrderBusy();
        self.updateOrderTotal();
      });
  };

  Customizer.prototype.designHandoff = function () {
    var viewToLocation = {
      front: 'custom-front',
      back: 'custom-back',
      'left-chest': 'left-chest'
    };
    var placements = [];
    var seen = {};

    ['front', 'back', 'left-chest'].forEach(function (view) {
      (this.viewState[view] || []).forEach(function (obj) {
        if (!obj || obj.blvKind === 'text') return;
        var name = obj.sourcePath || obj.name;
        var location = viewToLocation[view];
        if (!name || !location) return;
        var key = location + '\n' + name;
        if (seen[key]) return;
        seen[key] = true;
        placements.push({ location: location, file: name });
      });
    }, this);

    return {
      files: this.collectUsedArtwork(),
      placements: placements
    };
  };

  Customizer.prototype.saveProductionHandoff = function (record) {
    return new Promise(function (resolve, reject) {
      var request = window.indexedDB.open('blvnks', 1);
      request.onupgradeneeded = function () {
        var db = request.result;
        if (!db.objectStoreNames.contains('handoff')) {
          db.createObjectStore('handoff');
        }
      };
      request.onerror = function () { reject(request.error); };
      request.onsuccess = function () {
        var db = request.result;
        var tx = db.transaction('handoff', 'readwrite');
        tx.objectStore('handoff').put(record, 'customizer');
        tx.oncomplete = function () {
          db.close();
          resolve();
        };
        tx.onerror = function () { reject(tx.error); };
      };
    });
  };

  Customizer.prototype.startProductionRun = function () {
    var self = this;
    if (this.productionLeaving) return;
    this.productionLeaving = true;

    var color = getCurrentColorName(this.productData) || '';
    var handle = this.productData && this.productData.handle
      ? this.productData.handle
      : '';
    var productionUrl = this.productionUrl || '/pages/production';
    var url;

    this.syncCurrentViewState();
    var design = this.designHandoff();

    try {
      url = new URL(productionUrl, window.location.origin);
    } catch (error) {
      url = new URL('/pages/production', window.location.origin);
    }

    if (handle) url.searchParams.set('product', handle);
    if (color) url.searchParams.set('color', color);
    url.searchParams.set('from', 'customizer');

    var fileRecords = Promise.all(design.files.map(function (file) {
      var blob = file.raw || self.dataUrlToBlob(file.dataUrl, file.type);
      if (!blob || typeof blob.arrayBuffer !== 'function') {
        return Promise.resolve(null);
      }
      return blob.arrayBuffer().then(function (buffer) {
        return {
          name: file.name,
          type: file.type || blob.type || 'application/octet-stream',
          buffer: buffer
        };
      });
    })).then(function (files) {
      return self.saveProductionHandoff({
        version: 2,
        handle: handle,
        color: color,
        files: files.filter(Boolean),
        placements: design.placements
      });
    });

    fileRecords.then(function () {
      window.location.href = url.toString();
    }).catch(function (error) {
      console.warn('[blvnks-customizer] Could not persist production handoff', error);
      self.productionLeaving = false;
      window.location.href = url.toString();
    });
  };

  /* =========================================================
     BOOT
  ========================================================= */

  function boot() {
    document.querySelectorAll('[data-blv-customizer]').forEach(function (root) {
      if (root.dataset.blvCustomizerBooted === 'true') return;
      root.dataset.blvCustomizerBooted = 'true';
      new Customizer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();